export enum PurchasedElectricityType {
  POW_1 = 'POW_1',
  POW_2 = 'POW_2',
  POW_3 = 'POW_3',
  POW_4 = 'POW_4',

  IN_POW_1 = 'IN_POW_1',

  JP_POW_1 = 'JP_POW_1',
  JP_POW_2 = 'JP_POW_2',
  JP_POW_3 = 'JP_POW_3',
  JP_POW_4 = 'JP_POW_4',
  JP_POW_5 = 'JP_POW_5',
  JP_POW_6 = 'JP_POW_6',
  JP_POW_7 = 'JP_POW_7',
  JP_POW_8 = 'JP_POW_8',
  JP_POW_9 = 'JP_POW_9',
  JP_POW_10 = 'JP_POW_10',
  JP_POW_11 = 'JP_POW_11',
  JP_POW_12 = 'JP_POW_12',
  JP_POW_13 = 'JP_POW_13',
  JP_POW_14 = 'JP_POW_14',
  JP_POW_15 = 'JP_POW_15',
  JP_POW_16 = 'JP_POW_16',
  JP_POW_17 = 'JP_POW_17',
  JP_POW_18 = 'JP_POW_18',
  JP_POW_19 = 'JP_POW_19',
  JP_POW_20 = 'JP_POW_20',
  JP_POW_21 = 'JP_POW_21',
  JP_POW_22 = 'JP_POW_22',
  JP_POW_23 = 'JP_POW_23',
  JP_POW_24 = 'JP_POW_24',
  JP_POW_25 = 'JP_POW_25',
  JP_POW_26 = 'JP_POW_26',
  JP_POW_27 = 'JP_POW_27',
  JP_POW_28 = 'JP_POW_28',
  JP_POW_29 = 'JP_POW_29',
  JP_POW_30 = 'JP_POW_30',
  JP_POW_31 = 'JP_POW_31',
  JP_POW_32 = 'JP_POW_32',
  JP_POW_33 = 'JP_POW_33',
  JP_POW_34 = 'JP_POW_34',
  JP_POW_35 = 'JP_POW_35',
  JP_POW_36 = 'JP_POW_36',
  JP_POW_37 = 'JP_POW_37',

  TH_POW_1 = 'TH_POW_1',
  TH_POW_2 = 'TH_POW_2',
  TH_POW_3 = 'TH_POW_3',
  TH_POW_4 = 'TH_POW_4',
  TH_POW_5 = 'TH_POW_5',
  TH_POW_6 = 'TH_POW_6',

  US_POW_1 = 'US_POW_1',
  US_POW_2 = 'US_POW_2',
  US_POW_3 = 'US_POW_3',
  US_POW_4 = 'US_POW_4',
  US_POW_5 = 'US_POW_5',
  US_POW_6 = 'US_POW_6',
  US_POW_7 = 'US_POW_7',
  US_POW_8 = 'US_POW_8',
  US_POW_9 = 'US_POW_9',
  US_POW_10 = 'US_POW_10',
  US_POW_11 = 'US_POW_11',
  US_POW_12 = 'US_POW_12',
  US_POW_13 = 'US_POW_13',
  US_POW_14 = 'US_POW_14',
  US_POW_15 = 'US_POW_15',
  US_POW_16 = 'US_POW_16',
  US_POW_17 = 'US_POW_17',
  US_POW_18 = 'US_POW_18',
  US_POW_19 = 'US_POW_19',
  US_POW_20 = 'US_POW_20',
  US_POW_21 = 'US_POW_21',
  US_POW_22 = 'US_POW_22',
  US_POW_23 = 'US_POW_23',
  US_POW_24 = 'US_POW_24',
  US_POW_25 = 'US_POW_25',
  US_POW_26 = 'US_POW_26',
  US_POW_27 = 'US_POW_27',
  US_POW_28 = 'US_POW_28',

  CN_POW_1 = 'CN_POW_1',
  CN_POW_2 = 'CN_POW_2',
  CN_POW_3 = 'CN_POW_3',
  CN_POW_4 = 'CN_POW_4',
  CN_POW_5 = 'CN_POW_5',
  CN_POW_6 = 'CN_POW_6',
  CN_POW_7 = 'CN_POW_7',
  CN_POW_8 = 'CN_POW_8',
  CN_POW_9 = 'CN_POW_9',
  CN_POW_10 = 'CN_POW_10',
  CN_POW_11 = 'CN_POW_11',
  CN_POW_12 = 'CN_POW_12',
  CN_POW_13 = 'CN_POW_13',
  CN_POW_14 = 'CN_POW_14',
  CN_POW_15 = 'CN_POW_15',
  CN_POW_16 = 'CN_POW_16',
  CN_POW_17 = 'CN_POW_17',
  CN_POW_18 = 'CN_POW_18',
  CN_POW_19 = 'CN_POW_19',
  CN_POW_20 = 'CN_POW_20',
  CN_POW_21 = 'CN_POW_21',
  CN_POW_22 = 'CN_POW_22',
  CN_POW_23 = 'CN_POW_23',
  CN_POW_24 = 'CN_POW_24',
  CN_POW_25 = 'CN_POW_25',
  CN_POW_26 = 'CN_POW_26',
  CN_POW_27 = 'CN_POW_27',
  CN_POW_28 = 'CN_POW_28',
  CN_POW_29 = 'CN_POW_29',
  CN_POW_30 = 'CN_POW_30',
  CN_POW_31 = 'CN_POW_31',
  CN_POW_32 = 'CN_POW_32',
  CN_POW_33 = 'CN_POW_33',
  CN_POW_34 = 'CN_POW_34',
  CN_POW_35 = 'CN_POW_35',
  CN_POW_36 = 'CN_POW_36',
  CN_POW_37 = 'CN_POW_37',
  CN_POW_38 = 'CN_POW_38',
  CN_POW_39 = 'CN_POW_39',
  CN_POW_40 = 'CN_POW_40',

  US_POW_29 = 'US_POW_29',
  US_POW_30 = 'US_POW_30',
  US_POW_31 = 'US_POW_31',
  US_POW_32 = 'US_POW_32',
  US_POW_33 = 'US_POW_33',
  US_POW_34 = 'US_POW_34',
  US_POW_35 = 'US_POW_35',
  US_POW_36 = 'US_POW_36',
  US_POW_37 = 'US_POW_37',
  US_POW_38 = 'US_POW_38',
  US_POW_39 = 'US_POW_39',
  US_POW_40 = 'US_POW_40',
  US_POW_41 = 'US_POW_41',
  US_POW_42 = 'US_POW_42',
  US_POW_43 = 'US_POW_43',
  US_POW_44 = 'US_POW_44',
  US_POW_45 = 'US_POW_45',
  US_POW_46 = 'US_POW_46',
  US_POW_47 = 'US_POW_47',
  US_POW_48 = 'US_POW_48',
  US_POW_49 = 'US_POW_49',
  US_POW_50 = 'US_POW_50',
  US_POW_51 = 'US_POW_51',
  US_POW_52 = 'US_POW_52',
  US_POW_53 = 'US_POW_53',
  US_POW_54 = 'US_POW_54',
  US_POW_55 = 'US_POW_55',
  US_POW_56 = 'US_POW_56',
  US_POW_57 = 'US_POW_57',
  US_POW_58 = 'US_POW_58',
  US_POW_59 = 'US_POW_59',
  US_POW_60 = 'US_POW_60',
  US_POW_61 = 'US_POW_61',
  US_POW_62 = 'US_POW_62',
  US_POW_63 = 'US_POW_63',
  US_POW_64 = 'US_POW_64',
  US_POW_65 = 'US_POW_65',
}
